/**
 * Returns the query parameters from the current window location.
 *
 * Some links to our app stick everything behind a hash, so we have to take into
 * account cases where the link is "/#/foo/bar?baz"
 *
 * @param location - A `window.location` object, or a relative or fully qualified URL.
 */
export function getRawQueryParameters(
  location:
    | {
        search?: string;
        hash?: string;
      }
    | string,
): URLSearchParams {
  if (typeof location === 'string') {
    if (!location.startsWith('http')) {
      location = `http://example.com/${location}`;
    }
    location = new URL(location);
  }

  if (location.search) {
    return new URLSearchParams(location.search);
  } else if (location.hash) {
    const query = location.hash.split('?')[1];
    return new URLSearchParams(query);
  }

  return new URLSearchParams();
}
